import { createSlice } from '@reduxjs/toolkit'

import {
  cancelDeviceOrderAPI,
  completeDeviceOrderAPI,
  deliverDeviceOrderAPI,
  getDeviceOrderAPI,
  postDeviceOrderAPI,
  sendDeviceOrderSmsAPI,
  sendDeviceOrderToEcomAPI,
} from '@/api/deviceOrderApi'

import { setApiErrorPopup } from './popupReducer'

export const NAME = 'device-order'
// @ts-ignore
export const fetchDeviceOrder = orderId => async (dispatch, getState) => {
  const isPending = getIsPending(getState())
  if (isPending) return

  dispatch(pending())

  try {
    const order = await getDeviceOrderAPI(orderId)

    dispatch(success(order))
  } catch (error) {
    dispatch(setApiErrorPopup('Could not load order'))
    dispatch(failure('Could not load order'))
  }
}
// @ts-ignore
export const saveDeviceOrder = orderId => async (dispatch, getState) => {
  const isPending = getIsPostPending(getState())
  if (isPending) return

  dispatch(postPending())

  try {
    const orderOld = getDeviceOrder(getState())
    const orderNew = await postDeviceOrderAPI({ orderId, order: orderOld })

    dispatch(postSuccess(orderNew))
  } catch (error) {
    dispatch(setApiErrorPopup('Could not update order'))
    dispatch(postFailure('Could not update order'))
  }
}
// @ts-ignore
export const cancelDeviceOrder = orderId => async (dispatch, getState) => {
  const isPending = getIsPostPending(getState())
  if (isPending) return

  dispatch(postPending())

  try {
    const orderOld = getDeviceOrder(getState())
    const orderNew = await cancelDeviceOrderAPI({ orderId, order: orderOld })

    dispatch(postSuccess(orderNew))
  } catch (error) {
    dispatch(setApiErrorPopup('Could not cancel order'))
    dispatch(postFailure('Could not cancel order'))
  }
}
// @ts-ignore
export const completeDeviceOrder = orderId => async (dispatch, getState) => {
  const isPending = getIsPostPending(getState())
  if (isPending) return

  dispatch(postPending())

  try {
    const orderOld = getDeviceOrder(getState())
    const orderNew = await completeDeviceOrderAPI({ orderId, order: orderOld })

    dispatch(postSuccess(orderNew))
  } catch (error) {
    dispatch(setApiErrorPopup('Could not complete order'))
    dispatch(postFailure('Could not complete order'))
  }
}
// @ts-ignore
export const deliverDeviceOrder = orderId => async (dispatch, getState) => {
  const isPending = getIsPostPending(getState())
  if (isPending) return

  dispatch(postPending())

  try {
    const orderOld = getDeviceOrder(getState())
    const orderNew = await deliverDeviceOrderAPI({ orderId, order: orderOld })

    dispatch(postSuccess(orderNew))
  } catch (error) {
    dispatch(setApiErrorPopup('Could not deliver order'))
    dispatch(postFailure('Could not deliver order'))
  }
}
// @ts-ignore
export const sendDeviceOrderToEcom = orderId => async (dispatch, getState) => {
  const isPending = getIsPostPending(getState())

  if (isPending) return

  dispatch(postPending())

  try {
    const orderNew = await sendDeviceOrderToEcomAPI(orderId)

    dispatch(postSuccess(orderNew))
  } catch (error) {
    dispatch(setApiErrorPopup('Could not create order'))
    dispatch(postFailure('Could not create order'))
  }
}
// @ts-ignore
export const sendDeviceOrderSms = () => async (dispatch, getState) => {
  const isPending = getIsPostPending(getState())
  if (isPending) return

  dispatch(postPending())

  try {
    const order = getDeviceOrder(getState())
    const aliasId = getSelectedAlias(getState())
    const message = getSmsInputText(getState())
    const messages = await sendDeviceOrderSmsAPI({ orderId: order.id, aliasId, message })

    dispatch(
      postSuccess({
        ...order,
        sms_log: messages,
      })
    )
    dispatch(setSmsInputText(''))
  } catch (error) {
    dispatch(setApiErrorPopup('Could not send sms'))
    dispatch(postFailure('Could not send sms'))
  }
}

const initialState = {
  pending: false,
  isDataLoaded: false,
  error: undefined,
  postPending: false,
  postError: undefined,
  postSuccess: false,
  smsInputText: '',
  selectedAlias: 0,
  order: {},
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    pending: state => {
      state.error = undefined
      state.pending = true
    },
    success: (state, { payload: order }) => {
      state.pending = false
      state.isDataLoaded = true
      state.order = order
    },
    failure: (state, { payload: error }) => {
      state.pending = false
      state.isDataLoaded = true
      state.error = error
    },
    postPending: state => {
      state.postPending = true
      state.postError = undefined
      state.postSuccess = false
    },
    postSuccess: (state, { payload: order }) => {
      state.postPending = false
      state.postSuccess = true
      state.order = order
    },
    postFailure: (state, { payload: error }) => {
      state.postPending = false
      state.postError = error
      state.postSuccess = false
    },
    updateOrderProp: (state, { payload }) => {
      const { prop, value } = payload
      state.order = {
        ...state.order,
        [prop]: value,
      }
    },
    setSmsInputText: (state, { payload: text }) => {
      state.smsInputText = text
    },
    setAlias: (state, { payload: alias }) => {
      state.selectedAlias = alias
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const {
  pending,
  success,
  failure,
  postPending,
  postSuccess,
  postFailure,
  updateOrderProp,
  setSmsInputText,
  setAlias,
  reset,
} = actions
export default reducer

const getState = (state: any) => state[NAME]

export const getIsPending = (state: any) => getState(state).pending
export const getError = (state: any) => getState(state).error
export const getIsDataLoaded = (state: any) => getState(state).isDataLoaded

export const getIsPostPending = (state: any) => getState(state).postPending
export const getPostError = (state: any) => getState(state).postError
export const getIsPosted = (state: any) => getState(state).postSuccess

export const getSelectedAlias = (state: any) => getState(state).selectedAlias
export const getSmsInputText = (state: any) => getState(state).smsInputText

export const getDeviceOrder = (state: any) => getState(state).order
